import React, { Component } from 'react';
// Composants
import DataGrid from 'react-data-grid';
import InfoIcon from '../Utils/InfoIcon';
/*     Filters     */
import NumberFilter from '../Tables/Filters/NumberFilter';
import TextFilter from '../Tables/Filters/TextFilter';
// Librairies
import i18n from '../../locales/i18n';
import { connect } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
// Styles
import '../../styles/react-contextmenu.css';
import '../../styles/rdg.css';
// Utils
import FormattersUtil from '../../utils/FormattersUtil';

class PriceListTable extends Component {
    state = {
        data: {
            columns: [],
            rows: []
        }
    };

    render() {
        const { data, enableFilterRow } = this.state;
        const rows = this.getFilteredRows();

        return (
            <>
                {data?.columns &&
                    <>
                        <DataGrid
                            ref={this.gridRef} className={this.props.isDarkTheme ? 'rdg-dark' : 'rdg-light'}
                            style={{ flex: '1 1 auto', marginTop: '5px' }} headerRowHeight={0}
                            columns={data.columns} rows={rows}
                            defaultColumnOptions={{ resizable: true }}
                            cellNavigationMode='LOOP_OVER_ROW'
                            enableFilterRow={enableFilterRow}
                            emptyRowsRenderer={() => (<div style={{ textAlign: 'center' }}>
                                <span>{i18n.t("Aucun résultat trouvé")}</span>
                            </div>)}
                            onSelectedCellChange={({ idx, rowIdx }) => this.setState({ selectedRow: rows[rowIdx], selectedColumn: data.columns[idx] })}
                        />
                    </>}
            </>
        );
    }

    componentDidMount = () => {
        this.gridRef = React.createRef();
        this.loadData(this.props.priceList?.prices);
        document.addEventListener('keydown', this.handleKeyDown);
    }

    componentDidUpdate = (prevProps) => {
        if (prevProps.priceList.currencyId !== this.props.priceList.currencyId || prevProps.category !== this.props.category)
            this.loadData();
    }

    componentWillUnmount = () => document.removeEventListener('keydown', this.handleKeyDown);

    loadData = () => {
        const { priceList, category, availableProperties } = this.props;

        const data = { columns: [], rows: [] };

        // Définition des colonnes
        this.nbPrices = Math.max(...(priceList.priceThresholds || [])
            .filter(threshold => availableProperties[threshold.property]?.category === category)
            .map(threshold => threshold.values ? threshold.values.length + 1 : (category === 'Espace vert' ? 1 : 0)));
        if (this.nbPrices <= 1) this.nbPrices = 1;
        const currency = this.props.currencies.find(currency => currency.id === priceList.currencyId);
        const iconStyle = { marginLeft: '3px' };

        data.columns = [
            {
                name: i18n.t("Libellé"), key: 'label', width: 250, colSpan: (props) => props.row?.isMainHeaderRow ? this.nbPrices + 1 : 1,
                formatter: (props) => {
                    return props.row.isMainHeaderRow
                        ? <div className='disabled' style={{ fontWeight: 'bold', fontSize: '13pt' }}>{props.row.label}</div>
                        : (props.row.isSubHeaderRow
                            ? <div className='disabled' style={{ fontWeight: 'bold' }}>{props.row.label}</div>
                            : <div>{props.row.label}{props.row.definition && <InfoIcon content={props.row.definition} iconStyle={iconStyle} />}</div>)
                },
                filterRenderer: (props) => <TextFilter p={props} />
            },
            ...new Array(this.nbPrices).fill().map((_, index) => ({
                key: 'price' + (index + 1), width: 150,
                formatter: (props) => {
                    const thresholds = (props.row.property !== 'default' && priceList.priceThresholds?.find(threshold => threshold.property === props.row.property)?.values) || [];
                    const unit = availableProperties[props.row.property]?.unit;
                    let formattedCurrency = (currency?.symbol || currency?.code || '');
                    if (['surface', 'perimeter', 'length'].includes(props.row.property)) formattedCurrency += `/${availableProperties[props.row.property].unit}`;

                    return (
                        <div className={props.row.isSubHeaderRow ? 'disabled' : null} style={{ fontWeight: props.row.isSubHeaderRow ? 'bold' : 'normal' }}>
                            {(thresholds[index] || (thresholds.length && index === thresholds.length) || (!thresholds.length && !index)) && props.row['price' + (index + 1)] !== undefined
                                ? props.row['price' + (index + 1)] + (props.row.isSubHeaderRow ? (thresholds.length ? unit : '') : formattedCurrency)
                                : ''}
                        </div>
                    );
                },
                filterRenderer: (props) => <NumberFilter p={props} />
            }))
        ];

        const labelMap = new Map(this.props.project?.priceList?.prices?.filter(price => price.label?.trim()).map(price => [price.actionId, price.label]) || []);
        data.rows = JSON.parse(JSON.stringify(this.props.actions.filter(action => action.categories.includes(category)).map(action => {
            const price = priceList.prices.find(price => price.actionId === action.id);
            const values = price ? price.values || [] : new Array(6).fill().map((_, index) => action['price' + (index + 1)]);
            return {
                id: action.id,
                label: labelMap.get(action.id) || action.label,
                definition: action.definition,
                property: price ? (price.property || 'default') : action.defaultProperty,
                ...(values.reduce((prevValue, value, index) => ({ ...prevValue, ['price' + (index + 1)]: value }), {}))
            };
        }))).sort((a, b) => (Object.keys(availableProperties).indexOf(a.property) - Object.keys(availableProperties).indexOf(b.property)) || a.label.localeCompare(b.label));

        Object.keys(availableProperties)
            .filter(property => !availableProperties[property].category || availableProperties[property].category === category)
            .forEach(property => {
                const index = data.rows.findIndex(row => row.property === property);
                if (index !== -1) {
                    const values = priceList.priceThresholds?.find(threshold => threshold.property === property)?.values || [];
                    data.rows.splice(index, 0, {
                        id: uuidv4(), isSubHeaderRow: true, property, label: i18n.t("Libellé"), ...(
                            property === 'default'
                                ? { price1: i18n.t("Fixe") }
                                : values.length > 0 ?
                                    values.reduce((prevValue, value, index) => ({
                                        ...prevValue,
                                        ['price' + (index + 1)]: index
                                            ? `${i18n.t("De")} ${values[index - 1]} ${i18n.t("à")} ${value}`
                                            : `${i18n.t("De")} 0 ${i18n.t("à")} ${value}`
                                    }), {})
                                    : { price1: i18n.t("Toutes dimensions") }
                        ),
                        ['price' + (values.length ? (values.length + 1) : '-1')]: `> ${values[values.length - 1]}`
                    });
                    data.rows.splice(index, 0, { id: uuidv4(), isMainHeaderRow: true, property, label: availableProperties[property].label });
                }
            });

        // if (prices) {
        //     prices.forEach(price => {
        //         const row = data.rows.find(row => row.id === price.actionId);
        //         if (row) {
        //             row.priceId = price.id;
        //             row.isPriceFixed = price.isPriceFixed ? i18n.t("Oui") : i18n.t("Non");
        //             for (let i = 1; i <= 6; i++) row['price' + i] = price['price' + i];
        //             row.calculationUnit = units.find(unit => unit.value === price.calculationUnit)?.label;
        //         }
        //     })
        // }

        const initialOrder = data.rows.map(row => row.id);
        this.setState({ initialOrder });
        this.setState({ data });
    }

    getFilteredRows = () => {
        const { searchQuery } = this.props;
        let rows = [...this.state.data.rows];

        const $ = (str) => FormattersUtil.getNormalizedString(str);
        const headerRows = rows.filter(row => row.isMainHeaderRow || row.isSubHeaderRow).reverse();

        rows = rows.filter(r => (
            (!headerRows.includes(r) && (searchQuery ? $(r.label)?.includes($(searchQuery)) : true))
        ));

        headerRows.forEach(headerRow => {
            const index = rows.findIndex(row => row.property === headerRow.property);
            if (index !== -1) rows.splice(index, 0, headerRow);
        });

        return rows;
    }

    handleKeyDown = (e) => {
        if ((e.ctrlKey || e.metaKey) && e.key === 'c') {
            const { selectedColumn, selectedRow } = this.state;
            if (selectedColumn && selectedRow) navigator.clipboard.writeText(selectedRow[selectedColumn.key] || '');
        }
    }
}

const mapStateToProps = (state) => {
    return {
        isDarkTheme: state.isDarkTheme,
        actions: state.actions,
        currencies: state.currencies
    };
};

export default connect(mapStateToProps)(PriceListTable);